import React from "react";
import Header from "./Header";

const Layout = ({ children, header }) => {
  return (
    <div className="container mx-auto">
      {header && <Header />}
      <main>{children}</main>
    </div>
  );
};

export default Layout;
